module.exports = __webpack_public_path__ + "close.c4c396d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 83
// module chunks = 0